// extracted by mini-css-extract-plugin
export var main = "component-module--main--f5d81";
export var slim = "component-module--slim--9bebb";